import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes"; 
import AuthProvider from "./AuthProvider"; 


function App() {

  return (
    <AuthProvider>
    <Router>
    <AppRoutes />
    </Router>
    </AuthProvider>
  );
}

export default App;